import { useCallback, useState } from 'react'
import requestPasswordReset from 'src/dataLayer/remoteData/babbelAPI/submitPasswordReset'
import { useRouteParamsContext } from 'src/viewLayer/components/contexts/RouteParamsContext'

export default function useSubmitPasswordReset({
  captchaResponseToken,
  confirmPassword,
  password,
  passwordResetToken,
}) {
  const { locale } = useRouteParamsContext()
  const [isLoading, setIsLoading] = useState(false)
  const [errorKey, setErrorKey] = useState(null)
  const [data, setData] = useState(null)

  const makeResetPasswordRequest = useCallback(
    async (parameters = {}) => {
      // Use passed parameters or fall back to hook parameters
      const {
        captchaResponseToken: parameterCaptchaToken = captchaResponseToken,
        confirmPassword: parameterConfirmPassword = confirmPassword,
        password: parameterPassword = password,
        passwordResetToken: parameterPasswordResetToken = passwordResetToken,
      } = parameters

      if (
        !parameterCaptchaToken ||
        !parameterPassword ||
        !parameterConfirmPassword ||
        !parameterPasswordResetToken
      ) {
        return {
          error: 'Missing required parameters',
          success: false,
        }
      }

      setIsLoading(true)
      setErrorKey(null)
      setData(null)

      try {
        const result = await requestPasswordReset({
          captchaResponseToken: parameterCaptchaToken,
          confirmPassword: parameterConfirmPassword,
          locale,
          password: parameterPassword,
          passwordResetToken: parameterPasswordResetToken,
        })

        if (result.success) {
          setData(result.data)
          return result
        }
        setErrorKey(result.error)
        return result
      } catch (error) {
        const errorResult = {
          error: 'Network error occurred',
          message: error.message,
          networkError: true,
          success: false,
        }
        setErrorKey(errorResult.error)
        return errorResult
      } finally {
        setIsLoading(false)
      }
    },
    [locale],
  )

  return {
    error: errorKey,
    isResetPasswordRequestInProgress: isLoading,
    makeResetPasswordRequest,
    resetPasswordRequest: data,
  }
}
